(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filatrice-card-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('filatrice-card-video')) {
  customElements.define('filatrice-card-video', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.host = this.closest('.image-cont');
      this.slide = this.closest('.product-block__image');
      if (!this.host || !this.slide) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.pointerQuery = matchMedia('(hover: hover) and (pointer: fine)');
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.attempt = this.attempt || 0;
      this.requested = false;
      this.inView = false;
      this.pointerWithin = this.host.matches(':hover');

      this.host.addEventListener('mouseenter', () => {
        this.pointerWithin = true;
        this.sync();
      }, options);
      this.host.addEventListener('mouseleave', () => {
        this.pointerWithin = false;
        this.sync();
      }, options);
      this.pointerQuery.addEventListener('change', () => this.sync(), options);
      this.motionQuery.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      window.addEventListener('pagehide', () => this.stop(), options);
      window.addEventListener('pageshow', () => this.sync(), options);
      window.addEventListener('touchend', () => {
        if (!this.pointerQuery.matches) this.sync();
      }, { ...options, passive: true });

      this.slideObserver = new MutationObserver(() => this.sync());
      this.slideObserver.observe(this.slide, {
        attributes: true,
        attributeFilter: ['class']
      });

      if ('IntersectionObserver' in window) {
        this.viewportObserver = new IntersectionObserver((entries) => {
          const entry = entries[entries.length - 1];
          this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.15;
          this.sync();
        }, { threshold: [0, 0.15] });
        this.viewportObserver.observe(this.host);
      } else {
        const updateViewport = () => {
          const rect = this.host.getBoundingClientRect();
          this.inView = rect.width > 0 && rect.height > 0 &&
            rect.bottom > 0 && rect.top < window.innerHeight &&
            rect.right > 0 && rect.left < window.innerWidth;
          this.sync();
        };
        window.addEventListener('scroll', updateViewport, { ...options, passive: true });
        window.addEventListener('resize', updateViewport, options);
        updateViewport();
      }
      this.sync();
    }

    canPlay() {
      if (!this.isConnected || document.hidden || !this.inView ||
          this.motionQuery.matches ||
          this.slide.classList.contains('product-block__image--inactivated')) {
        return false;
      }

      if (this.pointerQuery.matches) {
        return this.pointerWithin &&
          this.slide.classList.contains('product-block__image--show-on-hover');
      }

      return this.slide.classList.contains('product-block__image--active');
    }

    sync() {
      if (this.canPlay()) {
        this.start();
      } else {
        this.stop();
      }
    }

    start() {
      if (!this.canPlay() || this.requested) return;
      this.requested = true;
      const attempt = ++this.attempt;
      this.removeAttribute('data-playback-error');

      if (!this.video) {
        this.video = this.querySelector('video');
        if (!this.video) {
          const template = this.querySelector('template');
          if (template) this.appendChild(template.content.cloneNode(true));
          this.video = this.querySelector('video');
        }
        if (!this.video) {
          this.stop();
          return;
        }

        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;
        this.video.autoplay = false;
        this.video.loop = true;
        this.video.setAttribute('muted', '');
        this.video.setAttribute('playsinline', '');
        this.video.removeAttribute('autoplay');

        const options = { signal: this.controller.signal };
        this.video.addEventListener('playing', () => {
          if (this.requested && this.canPlay() && !this.video.paused) {
            this.classList.add('is-visible', 'is-playing');
            this.host.classList.add('filatrice-card-video-playing');
          } else {
            this.stop();
          }
        }, options);
        this.video.addEventListener('pause', () => {
          if (this.video.paused) {
            this.requested = false;
            this.hide();
          }
        }, options);
        this.video.addEventListener('error', () => this.stop(), options);
      }

      this.classList.add('is-visible');
      this.host.classList.add('filatrice-card-video-playing');
      try {
        const playback = this.video.play();
        if (playback && typeof playback.catch === 'function') {
          playback.catch((error) => this.playbackFailed(error, attempt));
        }
      } catch (error) {
        this.playbackFailed(error, attempt);
      }
    }

    playbackFailed(error, attempt) {
      if (this.attempt !== attempt) return;
      this.requested = false;
      this.setAttribute('data-playback-error', error.name || 'PlaybackError');
      this.hide();
    }

    hide() {
      this.classList.remove('is-visible', 'is-playing');
      if (this.host) this.host.classList.remove('filatrice-card-video-playing');
    }

    stop() {
      this.requested = false;
      this.attempt = (this.attempt || 0) + 1;
      this.hide();
      if (this.video) {
        this.video.pause();
        if (this.video.readyState > 0) {
          try {
            this.video.currentTime = 0;
          } catch (error) {}
        }
      }
    }

    disconnectedCallback() {
      this.stop();
      if (this.slideObserver) this.slideObserver.disconnect();
      if (this.viewportObserver) this.viewportObserver.disconnect();
      if (this.controller) this.controller.abort();
      this.controller = null;
      this.video = null;
      this.pointerWithin = false;
      this.inView = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('filatrice-product-video-player')) {
  customElements.define('filatrice-product-video-player', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      const video = this.querySelector('video');
      const controls = this.querySelector('.filatrice-player__controls');
      const toggle = this.querySelector('[data-player-toggle]');
      const seek = this.querySelector('[data-player-seek]');
      const time = this.querySelector('[data-player-time]');
      const fullscreen = this.querySelector('[data-player-fullscreen]');
      const playIcon = this.querySelector('[data-player-play]');
      const pauseIcon = this.querySelector('[data-player-pause]');
      const expandIcon = this.querySelector('[data-player-expand]');
      const collapseIcon = this.querySelector('[data-player-collapse]');
      if (!video || !controls || !toggle || !seek || !time || !fullscreen || !playIcon || !pauseIcon || !expandIcon || !collapseIcon) return;

      this.video = video;
      this.controls = controls;
      this.originalControls = video.controls;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const currentFullscreen = () => document.fullscreenElement || document.webkitFullscreenElement;
      const requestFullscreen = this.requestFullscreen || this.webkitRequestFullscreen;
      const canFullscreen = Boolean(requestFullscreen && (document.fullscreenEnabled || document.webkitFullscreenEnabled));

      const formatTime = (seconds) => {
        if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
        const whole = Math.floor(seconds);
        const hours = Math.floor(whole / 3600);
        const minutes = Math.floor((whole % 3600) / 60);
        const rest = String(whole % 60).padStart(2, '0');
        return hours ? `${hours}:${String(minutes).padStart(2, '0')}:${rest}` : `${minutes}:${rest}`;
      };

      const updatePlayback = () => {
        const playing = !video.paused && !video.ended;
        toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        playIcon.toggleAttribute('hidden', playing);
        pauseIcon.toggleAttribute('hidden', !playing);
      };

      const updateTimeline = () => {
        const duration = video.duration;
        const available = Number.isFinite(duration) && duration > 0;
        const position = Number.isFinite(video.currentTime) ? Math.max(0, video.currentTime) : 0;
        seek.disabled = !available;
        seek.value = available ? String(Math.round(Math.min(1, position / duration) * 1000)) : '0';
        const elapsed = formatTime(position);
        const total = available ? formatTime(duration) : '0:00';
        time.textContent = `${elapsed} / ${total}`;
        seek.setAttribute('aria-valuetext', available ? `${elapsed} of ${total}` : elapsed);
      };

      const updateFullscreen = () => {
        const expanded = currentFullscreen() === this;
        fullscreen.hidden = !canFullscreen;
        fullscreen.setAttribute('aria-label', expanded ? 'Exit fullscreen' : 'Enter fullscreen');
        expandIcon.toggleAttribute('hidden', expanded);
        collapseIcon.toggleAttribute('hidden', !expanded);
      };

      const togglePlayback = () => {
        if (!video.paused && !video.ended) {
          video.pause();
          return;
        }
        try {
          const playback = video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(updatePlayback);
        } catch (error) {
          updatePlayback();
        }
      };

      controls.addEventListener('click', (event) => event.stopPropagation(), { signal });
      toggle.addEventListener('click', togglePlayback, { signal });
      video.addEventListener('click', togglePlayback, { signal });
      seek.addEventListener('input', () => {
        if (!Number.isFinite(video.duration) || video.duration <= 0) return;
        const fraction = Number(seek.value) / 1000;
        if (!Number.isFinite(fraction)) return;
        try {
          video.currentTime = Math.max(0, Math.min(1, fraction)) * video.duration;
        } catch (error) {
          // Metadata can change while a file is still loading.
        }
        updateTimeline();
      }, { signal });

      fullscreen.addEventListener('click', () => {
        if (!canFullscreen) return;
        try {
          let change;
          if (currentFullscreen() === this) {
            const exitFullscreen = document.exitFullscreen || document.webkitExitFullscreen;
            if (exitFullscreen) change = exitFullscreen.call(document);
          } else {
            change = requestFullscreen.call(this);
          }
          if (change && typeof change.catch === 'function') change.catch(updateFullscreen);
        } catch (error) {
          updateFullscreen();
        }
      }, { signal });

      ['play', 'playing', 'pause', 'ended', 'error'].forEach((name) => video.addEventListener(name, updatePlayback, { signal }));
      ['loadedmetadata', 'durationchange', 'timeupdate', 'emptied'].forEach((name) => video.addEventListener(name, updateTimeline, { signal }));
      document.addEventListener('fullscreenchange', updateFullscreen, { signal });
      document.addEventListener('webkitfullscreenchange', updateFullscreen, { signal });

      updatePlayback();
      updateTimeline();
      updateFullscreen();
      // Keep native controls as a fallback until every custom control is ready.
      video.controls = false;
      controls.hidden = false;
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.video) this.video.controls = this.originalControls;
      if (this.controls) this.controls.hidden = true;
      this.controller = null;
      this.video = null;
      this.controls = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
